module.exports = __webpack_public_path__ + "img/1566832783.a59554cf.jpg";